import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppUtils } from "@app/shared/util/app.utils";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolUsage } from "@app/tool/model/tool-usage.model";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable()
export class ToolUsageService {
    static readonly API_TOOL_USAGE_BASE_PATH = `${environment.baseURL}/api/toolUsage`;

    constructor(private http: HttpClient, private router: Router) {
    }

    getTools(tableConfig: TableConfig = null, hasListOfIds: boolean = false) {
        let params = new HttpParams();
        if (hasListOfIds) {
            params = AppUtils.buildPageableParamsFromList(tableConfig);
        } else {
            params = AppUtils.buildPageableParams(tableConfig);
        }
        return this.http.get(`${ToolUsageService.API_TOOL_USAGE_BASE_PATH}`, {
            params: params
        }).pipe(map(this.mapToolUsage));
    }

    getProductionData(toolIds: number[], priority: number = null) {
        let params = new HttpParams();
        toolIds.forEach(id => params = params.append('toolIds', id.toString()));
        if (priority) {
            params = params.append('operationPriority', priority.toString())
        }

        return this.http.get(`${ToolUsageService.API_TOOL_USAGE_BASE_PATH}/production-data`, {params: params});
    }

    private mapToolUsage = res => {
        return {
            items: res.items.map(tool => {
                return new ToolUsage(tool);
            }),
            count: res.total
        };
    }
}
